import React, { FC } from 'react';

import { EvFlexRow, EvInfoTooltip } from '@evinced-private/ui-common';

import { VALUES_TABLE_LABELS } from '../ValuesTable.labels';

export const DashboardColumnHeader: FC = () => (
	<EvFlexRow gap="SMALL" align="CENTER">
		<EvInfoTooltip title={VALUES_TABLE_LABELS.COLUMN_DASHBOARD_VISIBILITY}>
			{VALUES_TABLE_LABELS.COLUMN_DASHBOARD_VISIBILITY_TOOLTIP}
		</EvInfoTooltip>
		{VALUES_TABLE_LABELS.COLUMN_DASHBOARD_VISIBILITY}
	</EvFlexRow>
);
